// client/src/routes/app/fiscal/declarations.$declarationId/submission.tsx — SCR-FISC-005 ·
// FISC-007 (04 §8.11).
//
// „Jurnal de depuneri manuale": what the landlord recorded after filing on ANAF's own site.
// In V1 this screen is the ONLY thing that moves a declaration past CONFIRMED (§4.8, 02 §14.6).
//
// The guards are the branch's (`route.tsx`); this file is the screen.

import { createFileRoute } from '@tanstack/react-router';

import { SubmissionLogScreen } from '@/features/fiscal/SubmissionLogScreen';

export const Route = createFileRoute('/app/fiscal/declarations/$declarationId/submission')({
  component: SubmissionRoute,
});

function SubmissionRoute() {
  const { declarationId } = Route.useParams();
  return <SubmissionLogScreen declarationId={declarationId} />;
}
